module.exports = __webpack_public_path__ + "img/18_10.a1753cf2.png";